import styled from '@emotion/styled';

import { shouldForwardProp } from '@hrworks/design-system';
import { Button } from '@hrworks/sui-core/Button';
import { Scroller } from '@hrworks/sui-core/Scroller';

const ContentContainer = styled.div({
  gridArea: 'content',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
});

const Breadcrumb = styled.div(({ theme }) => ({
  padding: theme.eclipseResponsive.margin,
  paddingBottom: theme.eclipseResponsive.gutter,
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.eclipseTier1.spacing['12px'],
  flexWrap: 'wrap',
  alignItems: 'center',
  zIndex: 2,
  clipPath: 'inset(0 0 -100% 0)',

  '&[data-shadow="true"]': {
    boxShadow: theme.eclipseTier2Color.elevation.shadow.overflow.boxShadow,
  },
}));

const BreadcrumbButton = styled(Button)({
  alignSelf: 'start',
});

type ContentProps = { $borderless?: boolean; $showBreadcrumb?: boolean };

const Content = styled(Scroller, { shouldForwardProp })<ContentProps>(({ theme, $borderless, $showBreadcrumb }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  transition: `padding ${theme.marko.variables.animationDuration.long}`,

  ...(!$borderless && {
    padding: theme.eclipseResponsive.margin,

    ...($showBreadcrumb && { paddingTop: 0 }),
  }),
}));

const Children = styled.div({
  flex: 1,
});

const ContentHeader = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.eclipseResponsive.margin,
}));

export const S = {
  ContentContainer,
  Breadcrumb,
  BreadcrumbButton,
  Content,
  ContentHeader,
  Children,
} as const;
